import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { OptIn } from '../pages/PublicBroadcastPreference/OptIn';
import { OptOut } from '../pages/PublicBroadcastPreference/OptOut';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 0,
    },
  },
});

/** Routes accessible without authentication */
const PublicRoutes = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <Routes>
        <Route path="opt-in" element={<OptIn />} />
        <Route path="opt-out" element={<OptOut />} />
      </Routes>
    </QueryClientProvider>
  );
};

export default PublicRoutes;
